<template>
  <div>
    <el-form label-width="80px" style="width:350px;">
      <el-form-item label="OA用户">
        <el-select
          v-model="oaUser"
          filterable
          remote
          reserve-keyword
          placeholder="用户名进行模糊查询"
          value-key="userId"
          :remote-method="getOaUserByKey"
        >
          <el-option
            v-for="item in oaUserList"
            :key="item.userId"
            :label="`${item.userName}  ${item.deptName}`"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="switchOa">切换</el-button>
      </el-form-item>
    </el-form>

    <el-form label-width="80px" style="width:350px;">
      <el-form-item label="渠道用户">
        <el-select
          v-model="partnerUser"
          filterable
          remote
          reserve-keyword
          placeholder="渠道用户名进行模糊查询"
          :remote-method="getPartnerUserByKey"
          value-key="userId"
        >
          <el-option
            v-for="item in partnerUserList"
            :key="item.userId"
            :label="item.userName"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="switchPartner">切换</el-button>
      </el-form-item>
    </el-form>

    <el-form label-width="80px" style="width:350px;">
      <el-form-item label="海外内部用户">
        <el-select
          v-model="userModel"
          filterable
          multiple
          remote
          :reserve-keyword="false"
          :placeholder="$t('homePage.pleaseEnterDesignatedShare')"
          :remote-method="remoteMethodUserBydebounce"
          :loading="loading"
          value-key="userId"
        >
          <el-option
            v-for="item in userOptions"
            :key="item.userId"
            :label="item.userName"
            :value="item"
          >
            <span>
              <span style="width: 140px;display: inline-block">
                {{ `[${$t('homePage.name')}]：` + item.userName }}
              </span>
              <span>
                [{{ $t('homePage.department') }}]：
              </span>
              <span v-if="item.deptName == null">
                {{ $t('homePage.notHave') }}
              </span>
              <span v-if="item.deptName != null">
                {{ item.deptName }}
              </span>
              <span v-if="item.partnerType != null">
                {{ `[${$t('homePage.channelType')}]：` + item.partnerType }}
              </span>
            </span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="switchOa">切换</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from '../../api';
import XEUtils from 'xe-utils';

export default {
  data () {
    return {
      oaUser: {},
      partnerUser: {},
      oaUserList: [],
      partnerUserList: [],
      userModel: {},
      userOptions: [],
      loading: false,
    };
  },
  mounted () {
    this.swtichUserAuthority();
  },
  methods: {
    getOaUserByKey (key) {
      api.getOaUserByKey(key)
        .then(resp => {
          if (resp.data.status == 200) {
            this.oaUserList = resp.data.data;
          }
        })
        .catch(e => {
          console.log('e', e);
        });
    },
    getPartnerUserByKey (key) {
      api.getPartnerUserByKey(key)
        .then(resp => {
          if (resp.data.status == 200) {
            this.partnerUserList = resp.data.data;
          }
        })
        .catch(e => {
          console.log('e', e);
        });
    },
    switchOa () {
      console.log("ppp=",this.userModel);
      api.switchUser(this.userModel[0].userId)
        .then(resp => {
          if (resp.data.status == 200) {
            window.location.href = '/';
          }
        })
        .catch(e => {
          console.log('e', e);
        });
    },
    switchPartner () {
      api.switchUser({ params: { 'userId': this.partnerUser.userId } })
        .then(resp => {
          if (resp.data.status == 200) {
            window.location.href = '/';
          }
        })
        .catch(e => {
          console.log('e', e);
        });
    },
    swtichUserAuthority () {
      api.swtichUserAuthority()
        .then(resp => {
          if (resp.data.status == 200) {

          }
        })
        .catch(e => {
          console.log('e', e);
        });
      console.log('user', this.oaUser);
    },
    // 创建一个防反跳策略函数，调用频率间隔 200 毫秒
    remoteMethodUserBydebounce: XEUtils.debounce(
      function (query) {
        this.remoteMethodUser(query);
      },
      1300
    ),
    // 根据关键字检索用户 > 指定人分享
    remoteMethodUser (query) {
      if (query !== '') {
        this.loading = true;
        api.seachUserByKey({ params: { 'key': query } }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.loading = false;
            this.userOptions = json.data;
          } else {
            this.$notify.error(json.data);
          }
        }).catch(() => {
          this.$notify.error('网络异常!');
        });
      } else {
        this.userOptions = [];
      }
    }
  }
};
</script>
